import FaqsAccordion from './Contact/FaqsAccordion.vue';
import FooterMarquee from './Footer/FooterMarquee.vue';
import HomeIntroCarousel from './Home/IntroCarousel.vue';
import LeadsForm from './Contact/LeadsForm.vue';
import LocationCarousel from './Location/LocationCarousel.vue';
import LocationMenu from './Location/Menu/LocationMenu.vue';
import MobileHeader from './Header/MobileHeader.vue';
import PolaroidCarousel from './Polaroids/PolaroidCarousel.vue';
import ReservationForm from './Reservations/ReservationForm.vue';
import RestaurantsListViewport from './RestaurantsList/RestaurantsListViewport.vue';
import UiButton from './Ui/UiButton.vue';
import CountdownBar from './Home/CountdownBar.vue';
import HomeTakeover from './Home/HomeTakeover.vue';

export const rootComponents = {
    CountdownBar,
    FaqsAccordion,
    FooterMarquee,
    HomeIntroCarousel,
    LeadsForm,
    LocationCarousel,
    LocationMenu,
    MobileHeader,
    PolaroidCarousel,
    ReservationForm,
    RestaurantsListViewport,
    UiButton,
    HomeTakeover,
};
